module.exports = __webpack_public_path__ + "img/sol_black.bf8cae8d.png";